var app = angular.module('directives.booking', []);

	require('./directives/booking.directive.js');
	require('./stylesheet/style.scss');

module.exports = app;



/*****************
 ** WEBPACK FOOTER
 ** ./app/directives/booking/index.js
 ** module id = 134
 ** module chunks = 1
 **/